











import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class Breadcrumbs extends Vue {
	@State private crumbs!: any;

	private maxCrumbLength(crumb: string) {
		const MAX_LENGTH = 30;
		if (crumb === null) { return ' '; }
		if (crumb.length > MAX_LENGTH) {
			return crumb.substr(0, MAX_LENGTH) + '...';
		}
		return crumb;
	}
}
